<template>
	<span class="ToggleField">
		<input :type="type" :name="name" :checked="isChecked" :value="value" :disabled="!enabled" @change="onChange($event)" @click="$emit('click')" />
	</span>
</template>

<script>
	// https://www.smashingmagazine.com/2017/08/creating-custom-inputs-vue-js/

	export default {
		model: {
			prop: 'modelValue',
			event: 'change',
		},

		props: {
			type: {
				type: String,
				default: 'checkbox',
			},
			name: {
				type: String,
				default: 'toggle',
			},
			checked: {
				type: Boolean,
				default: null,
			},
			value: {
				default: null,
			},
			enabled: {
				type: Boolean,
				default: true,
			},
			modelValue: {
				default: false,
			},
			unCheckedValue: {
				default: null,
			},
			// trueValue: {
			// 	default: true,
			// },
			// falseValue: {
			// 	default: false,
			// },
		},

		// data() {
		// 	return {
		// 		inputValue: null,
		// 	};
		// },

		computed: {
			isChecked() {
				if (this.checked === null) {
					// v-model
					return this.modelValue === this.value;
				} else {
					// through props
					return this.checked;
				}
			}
		},

		methods: {
			onChange(event) {
				if (event.target.checked) {
					this.$emit('change', this.value);
					this.$emit('onchange', true);
				} else {
					this.$emit('change', this.unCheckedValue);
					this.$emit('onchange', false);
				}
			},
		},
	};
</script>
